
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/2021-10-04-d3-to-visx-barchart",
      function () {
        return require("private-next-pages/blogs/2021-10-04-d3-to-visx-barchart/index.page.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/2021-10-04-d3-to-visx-barchart"])
      });
    }
  